<template>
  <section id="page-intro-zeroone">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-dark">
          <h3>{{ title }}</h3>
        </div>

        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '../utils/Clearfix'

  Vue.use(VueAxios, axios)

  export default {
    props: { title: String },
    components: { Clearfix }
  }
</script>

<style>
  #page-intro-zeroone {
    background: url('../../assets/img/bg/zeroone.png') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// SectionIntroZeroOne.vue?8be48a68